export default "__VITE_ASSET__C1B8LCzk__"